import { createContext, useContext, useSyncExternalStore } from 'react';

/** Below this width (phones, and tablets held upright) the terminal uses the mobile layout instead of the dock. */
export const MOBILE_QUERY = '(max-width: 899px)';

const media = () => (typeof matchMedia === 'function' ? matchMedia(MOBILE_QUERY) : null);

/** Whether the screen is narrow enough for the mobile layout; follows rotation and window resizing. */
export function useIsNarrow(): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const m = media();
      m?.addEventListener('change', onChange);
      return () => m?.removeEventListener('change', onChange);
    },
    () => media()?.matches ?? false,
    () => false,
  );
}

/** Which layout a panel is shown in: panels adapt (cards instead of wide tables, taps instead of double-clicks). */
export const LayoutContext = createContext<{ mobile: boolean }>({ mobile: false });
export const useLayout = () => useContext(LayoutContext);
